import { render } from "./config.vue?vue&type=template&id=4c4ca8a2"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"

import "./config.vue?vue&type=style&index=0&id=4c4ca8a2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__